import {
  DirectionsServiceEnum,
  getInnerArray,
  getStationRouteInfoFromRideMetadata,
  getStationRouteRealStations,
  IRideDto,
  IRideMetadata,
  IStationRouteDto,
  IStationRouteResult,
  Log,
  SystemSettingsDto,
  transformRideMetadataToStationRouteResult,
  withStationRouteRoutingEngineMetadata,
} from "@ryde/shared";

export const useNewStationRouteTemplate = () => {
  const getNewStationRouteTemplate = ({
    rideDto,
    systemParams,
  }: {
    rideDto?: Partial<IRideDto>;
    systemParams?: SystemSettingsDto;
  } = {}): Partial<IStationRouteDto> => {
    let result: IStationRouteResult | undefined;
    const rideMetadata = rideDto?.metadata || ({} as IRideMetadata);
    const stationRouteConvertResult = transformRideMetadataToStationRouteResult(
      rideMetadata || {},
    );

    if (stationRouteConvertResult.success && stationRouteConvertResult.data) {
      result = stationRouteConvertResult.data;
    } else {
      Log.warn(
        "Error getting route info from ride metadata",
        stationRouteConvertResult.error,
      );
    }

    const stationInfos = getStationRouteInfoFromRideMetadata(
      rideMetadata || {},
    );
    const realStations = getStationRouteRealStations(stationInfos);
    const firstStation = realStations.at(0);
    const lastStation = realStations.at(-1);
    const routingEngine =
      systemParams?.metadata?.directionsService || DirectionsServiceEnum.Google;
    const newStationRoute: Partial<IStationRouteDto> = {
      customized: true,
      frozen: true,
      optimized: true,
      originStationId: firstStation?.id,
      destinationStationId: lastStation?.id,
      originStationName: firstStation?.name,
      destinationStationName: lastStation?.name,
      waypointIds: getInnerArray(realStations.map(x => x.id)),
      avoidTolls: systemParams?.metadata?.avoidTolls || false,
      metadata: withStationRouteRoutingEngineMetadata({
        metadata: {
          sourceRideId: rideDto?.id,
          direction: rideDto?.direction,
        },
        engine: routingEngine,
      }),
      computedData: { stationInfos },
      virtualData: {
        excludedStationRouteIds: rideMetadata?.excludedStationRouteIds || [],
        rideOpenerId: rideDto?.id,
      },
      result,
    };
    return newStationRoute;
  };

  return { getNewStationRouteTemplate };
};
